import { defaultApi } from "@/config/httpClient"
import {SettingsDto, UserDto, ChatTokenDto} from "@/generated/openapi"

/**
 * Get tenant settings from API
 */
class SettingsService {
  public getSettings(): Promise<SettingsDto[]> {
    return defaultApi.getSettings().then(response => {
      return response.data
    }).catch(err => {
      throw err
    })
  }

  public getCurrentUser(): Promise<UserDto> {
    return defaultApi.getCurrentUser().then(response => {
      return response.data
    }).catch(err => {
      throw err
    })
  }

  public getChatToken(): Promise<ChatTokenDto> {
    return defaultApi.getChatToken().then(response => {
      return response.data
    }).catch(err => {
      throw err
    })
  }
}
const settingsService = new SettingsService()
export default settingsService
